import {debounce} from "js/debounce/debounce"
import {makeRequest} from "js/request-api/request-api"

export const initProductFiltration = async () => {
  const responseSettings = {
    method: "GET",
  }

  const section = document.querySelector<HTMLElement>(".s-product-list")
  const empty = document.querySelector<HTMLElement>(".s-product-list__empty")
  const filterBody = document.querySelector<HTMLElement>(".f-filtration__body")
  const selectedList = document.querySelector<HTMLElement>(".i-filtration-visual")

  if (!section) return;

  const group = section?.querySelector<HTMLElement>(".g-product")
  const groupCategories = document?.querySelector<HTMLElement>(".g-categories, .f-category__items")
  const itemLimit = group?.dataset.limit
  const paginationWrapper = section?.querySelector<HTMLElement>(".--js-pagination-wrap")

  const getApiUrl = (page?: string) => {
    const apiBase = `/front/api/product-list/products/`
    const apiUrl = new URL(`${window.location.origin}${apiBase}`);
    const newFilter = document.querySelector<HTMLFormElement>(".f-filtration__form")
    const newFormCategory = document.querySelector<HTMLFormElement>(".f-category")
    const categoryId = newFilter?.dataset.categoryId;
    const familyId = newFilter?.dataset.familyId;

    if (newFilter) {
      new FormData(newFilter).forEach((value, name) => {
        if (value) apiUrl.searchParams.append(name, value.toString())
      })
    }

    if (newFormCategory) {
      new FormData(newFormCategory).forEach((value, name) => {
        if (value) apiUrl.searchParams.append(name, value.toString())
      })
    }

    if (page) {
      apiUrl.searchParams.append("page", page)
    }

    if (itemLimit) {
      apiUrl.searchParams.append("limit", itemLimit)
    }

    if (categoryId) {
      apiUrl.searchParams.append("categoryId", categoryId)
    }

    if (familyId) {
      apiUrl.searchParams.append("familyId", familyId)
    }

    return apiUrl.toString()
  }

  const dispatchFilterEvent = () => {
    section?.dispatchEvent(new Event("filter"))
  }

  const dispatchFilterEventDebounced = debounce(() => dispatchFilterEvent())

  const filterProducts = async (page?: string) => {
    group?.classList.add("--loading")
    groupCategories?.classList.add("--loading")
    filterBody?.classList.add("--loading")
    setDisabled()

    const response = await makeRequest(getApiUrl(page), responseSettings)

    if (!response.ok) {
      group?.classList.remove("--loading")
      groupCategories?.classList.remove("--loading")
      filterBody?.classList.remove("--loading")

      return
    }

    const data = (await response.json()) as productsData

    if (data.success) {
      history.replaceState(null, "", data.url)

      if (!data.html) {
        empty?.classList.remove("--hidden")
        group?.classList.add("--hidden")
      } else {
        empty?.classList.add("--hidden")
        group?.classList.remove("--hidden")
      }

      if (filterBody) filterBody.innerHTML = data.filter ?? ""
      inputsInit()

      if (selectedList) selectedList.innerHTML = data.selected ?? ""

      if (group) group.innerHTML = data.html

      if (groupCategories) groupCategories.innerHTML = data.categoryItems ?? ""
      categoriesInit()

      if (paginationWrapper) paginationWrapper.innerHTML = data.pagination ?? ""
      paginationInit()
    }

    group?.classList.remove("--loading")
    groupCategories?.classList.remove("--loading")
    filterBody?.classList.remove("--loading")
    setEnabled()

    document.dispatchEvent(new Event("rangeReinit"))
    document.dispatchEvent(new Event("checkboxSelectReinit"))
    document.dispatchEvent(new Event("overlayscrollbarsReinit"))
    document.dispatchEvent(new Event("filterListReinit"))
    document.dispatchEvent(new Event("filterClearReinit"))
    window.lazyloading?.update()
  }

  const setDisabled = () => {
    const filter = document.querySelector<HTMLFormElement>(".f-filtration__form")
    const inputs = filter?.querySelectorAll<HTMLInputElement>('input[name]')

    inputs?.forEach((input) => {
      if (input.value == input.min || input.value == input.max) input.disabled = true;
    })
  }

  const setEnabled = () => {
    const filter = document.querySelector<HTMLFormElement>(".f-filtration__form")
    const inputs = filter?.querySelectorAll<HTMLInputElement>('input[name]')

    inputs?.forEach((input) => {
      if ((input.value == input.min || input.value == input.max) && input.min !== input.max) input.disabled = false;
    })
  }

  section?.addEventListener("filter", async () => {
    await filterProducts()
  })

  const inputsInit = () => {
    const newFilter = document.querySelector<HTMLFormElement>(".f-filtration__form")
    const newInputs = newFilter?.querySelectorAll<HTMLInputElement>('input[name]')

    newInputs?.forEach((input) => input.addEventListener("change", dispatchFilterEventDebounced))
  }

  inputsInit()

  const categoriesInit = () => {
    const newFormCategory = document.querySelector<HTMLFormElement>(".f-category")
    const newCategories = newFormCategory?.querySelectorAll<HTMLInputElement>("input[name]")

    newCategories?.forEach((category) => category.addEventListener("change", dispatchFilterEventDebounced))
  }

  categoriesInit()

  const paginationInit = () => {
    const paginationLinks = paginationWrapper?.querySelectorAll<HTMLElement>(".c-pagination__link")

    paginationLinks?.forEach((link) =>
      link.addEventListener("click", async (event: Event) => {
        event.preventDefault()
        const page = link.dataset.page ?? ""
        await filterProducts(page).then(() => {
          section?.scrollIntoView({behavior: "instant", block: "start"})
        })
      }),
    )
  }

  paginationInit()
}

initProductFiltration()

type productsData = {
  html: string
  filter: string
  selected: string
  pagination: string
  success: boolean
  categoryItems: string
  url: string
}
